import "./Code.css"
import React from 'react'
import Window from "./Window"
import { observer, inject } from "mobx-react"

const Code = ({app, code})=> {
  const title = <span>P E R S 0 N A L 1 T Y</span>
  return <Window title={title} className="Code" width={app.size.width/2} height={app.size.height}>
    <div className="Code__wrap">
      <pre lang="Javascript">{ code }</pre>
    </div>
  </Window>
}

export default inject(["app"])(observer(Code))


// WEBPACK FOOTER //
// ./src/components/Code.js